import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import { getDocumentsWeb } from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchDocuments = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllDocuments },
	} = useAssetDetailsContext();

	return async (documentSearch?: string) => {
		setIsLoading(true);
		const res = await getDocumentsWeb(documentSearch || null);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			const allDocumentMap: any = {};
			rowsSource.forEach((row: any) => {
				allDocumentMap[row.DocumentName?.trim()] = row;
			});
			setListAllDocuments(allDocumentMap);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message);
		}
	};
};
